import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const NavigationWrapper = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  position: "relative",
  width: "100%"
}));

export const DotColumn = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  gap: "0.35rem",
  paddingTop: theme.spacing(2),
  width: 24
}));

export const CardsColumn = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  minWidth: 0,
  gap: "0.5rem"
  // height: "28rem"
}));

interface DotButtonProps {
  $active: boolean;
  $isComplete: boolean;
  $isNavigationDot: boolean;
}

export const DotButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "$active"
})<DotButtonProps>(({ $active, $isComplete, theme, $isNavigationDot }) => ({
  background: $active
    ? theme.customColors.accentVariantA
    : $isComplete
      ? theme.customColors.borderSecondaryComplete
      : theme.customColors.border,
  border: "none",
  borderRadius: "50%",
  cursor: "pointer",
  height: $active ? "0.875rem" : "0.75rem",
  outline: "none",
  padding: 0,
  transition: "all 0.15s ease-in-out",
  width: $active ? "0.875rem" : "0.75rem",
  ...$isNavigationDot && {
    width: "0.5rem",
    height: "0.5rem"
  },
  "&:focus-visible": {
    boxShadow: `0 0 0 2px ${theme.palette.primary?.main}`,
    outline: "none"
  }
}));


export const CardSlot = styled(Box)(() => ({
  display: "grid",
  gridTemplateRows: "0fr",
  transition: "grid-template-rows 0.15s ease-in-out",
  opacity: 0,
  pointerEvents: "none"
}));

export const CardSlotInner = styled(Box)(() => ({
  minHeight: 0, // fondamentale: senza questo, i grid item non collassano sotto il contenuto
  overflow: "hidden"
}));
